import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '../common';
import styles from '../../styles/components/BottomNav.module.css';

function BottomNav() {
  const { t } = useTranslation();

  const navItems = [
    { path: '/', icon: 'store', label: t('bottomNav.store') },
    { path: '/earnings', icon: 'chart', label: t('bottomNav.earnings') },
    { path: '/promotion', icon: 'megaphone', label: t('bottomNav.promotion') },
    { path: '/settings', icon: 'settings', label: t('bottomNav.settings') },
  ];

  return (
    <nav className={styles.bottomNav}>
      <div className={styles.navContent}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.navItemActive : ''}`
            }
          >
            {({ isActive }) => (
              <>
                {isActive && <span className={styles.activeIndicator} />}
                <span className={styles.navIcon}>
                  <Icon name={item.icon} size="md" />
                </span>
                <span className={styles.navLabel}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default BottomNav;
